import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import Select from 'react-select';

import QuestionOptionsChangeStatus from './QuestionOptionsChangeStatus';

class QuestionOptionsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      active: '0',
      correct: '0',
      name: '',
      dados: [],
    };
    this.trocarActive = this.trocarActive.bind(this);
    this.trocarCorrect = this.trocarCorrect.bind(this);
    this.botaoEdicao = this.botaoEdicao.bind(this);
    this.adicionarOpcoes = this.adicionarOpcoes.bind(this);
    this.deletarLinha = this.deletarLinha.bind(this);
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.opcoes)) {
      this.setState({dados: newProps.opcoes});
    }
  }

  adicionarOpcoes(event) {
    event.preventDefault();
    var dados_salvar = {
      name: this.state.name,
      question_id: this.props.question_id,
    };
    var header = this.refs.request_api.header('application/json');
    this.props.handleAlert('', '', 'open');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/questao/opcao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.refreshTable(responseJson);
        } else {
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  //Funcao para trocar na tabela
  trocarActive(question_option) {
    var dados_temp = this.state.dados;
    dados_temp.map(function(dado, index){
      if (dado.id == question_option.id) {
        dados_temp[index].active = question_option.active_str;
      }
    });
    this.setState({dados: dados_temp});
  }

  //Funcao para trocar na tabela
  trocarCorrect(question_option) {
    var dados_temp = this.state.dados;
    dados_temp.map(function(dado, index){
      if (dado.id == question_option.id) {
        dados_temp[index].correct = question_option.correct_str;
      }
    });
    this.setState({dados: dados_temp});
  }

  deletarLinha(question_option_id) {
    var dados = this.state.dados;
    dados.map(function(dado, index){
      if (dado.id == question_option_id) {
        dados.splice(index, 1);
      }
    });
    this.setState({dados: dados});
  }

  botaoEdicao (cell, row) {
    var dados = this.state.dados;
    var active = '';
    var correct = '';
    dados.map(function(dado, index){
      if (dado.id == cell) {
        if (dado.active === "Sim") {
          active = 1;
        } else {
          active = 0;
        }
        if (dado.correct === "Sim") {
          correct = 1;
        } else {
          correct = 0;
        }
      }
    });
    return (
      <QuestionOptionsChangeStatus handleAlert={this.props.handleAlert} refreshTable={this.props.refreshTable} deletarLinha={this.deletarLinha} trocarActive={this.trocarActive} trocarCorrect={this.trocarCorrect} correct={correct} active={active} question_option_id={cell} />
    );
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.adicionarOpcoes}> 
    <div className="row">
      <div className="col-md-12">
        <div className="form-group">
            <label>Nome da Opção:</label>
            <textarea style={{ height: 200 }} type="text" name="name" className="form-control" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} required />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <button type="submit" className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> Adicionar opção</button>
      </div>
    </div>
  </form>
  <hr/>
  <table className="table table-bordered table-stripped table-hover">
    <thead>
      <tr>
        <th className="text-center">Opção</th>
        <th className="text-center">Correta?</th>
        <th className="text-center">Ativa</th>
        <th className="text-center">Ações</th>
      </tr>
    </thead>
    <tbody id="suppliers-certifications">
      {Object.keys(self.state.dados).map(function(k) {
        var active = '';
        var correct = '';
        if (self.state.dados[k].active === "Sim") {
          active = 1;
        } else {
          active = 0;
        }
        if (self.state.dados[k].correct === "Sim") {
          correct = 1;
        } else {
          correct = 0;
        }
        return (
          <tr>
            <td className="text-center">{self.state.dados[k].opcao}</td>
            <td className="text-center">{self.state.dados[k].correct}</td>
            <td className="text-center">{(self.state.dados[k].active === 'Sim') ?  <span className="label label-success">ativo</span> : <span className="label label-danger">inativo</span>}</td>
            <td className="text-center col-md-2">
              <QuestionOptionsChangeStatus handleAlert={self.props.handleAlert} refreshTable={self.props.refreshTable} deletarLinha={self.deletarLinha} trocarActive={self.trocarActive} trocarCorrect={self.trocarCorrect} correct={correct} active={active} question_option_id={self.state.dados[k].id} />
            </td>
          </tr>
        );
      })}
    </tbody>
  </table>
</div>
    );
  }
}

export default QuestionOptionsTab;



// WEBPACK FOOTER //
// ./src/Components/Questions/Elements/QuestionOptionsTab.js